import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from '@/app/app-router'
import { useSession } from '@/hooks/use-session'
import { SignInPage } from '@/pages/sign-in/sign-in-page'

function App(): React.JSX.Element {
  const session = useSession()

  if (session.isPending) {
    return (
      <div className="grid min-h-svh place-items-center text-sm text-muted-foreground">
        Loading…
      </div>
    )
  }
  if (!session.data) return <SignInPage error={session.error?.message} />

  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  )
}

export default App
